import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { ExternalPatientRoleGuard } from "../../shared/authguards/external-patient-role.guard";
import { MobileOnlyGuard } from "../../shared/authguards/mobile-only.guard";

export const MAIN_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () => import("./main.component").then(m => m.MainComponent),
    data: { title: "pageTitles.mainPage" },
    canActivate: [AuthGuard, epakRoleGuard, ExternalPatientRoleGuard],
    children: [
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.message" },
      }
    ],
  },
  {
    path: "ward-info",
    loadComponent: () => import("./ward-info/ward-info.component").then(m => m.WardInfoComponent),
    data: { title: "pageTitles.wardInfo" },
    canActivate: [AuthGuard, epakRoleGuard],
  },
  {
    path: "my-health",
    loadComponent: () => import("./my-health/my-health.component").then(m => m.MyHealthComponent),
    data: { title: "sideBottomNav.myHealth" },
    canActivate: [AuthGuard, epakRoleGuard, ExternalPatientRoleGuard],
  },
  {
    path: "more",
    loadComponent: () => import("../layout/more-menu/more-menu.component").then(m => m.MoreMenuComponent),
    data: { title: "sideBottomNav.more" },
    canActivate: [AuthGuard, ExternalPatientRoleGuard, MobileOnlyGuard],
  },
];
